import Global from './theme/global';
import '../_legacy/ui/js/storage-factory';
import '../_legacy/core/js/scripts';
import '../_legacy/ui/js/theme';
import ml from 'miva-layout';

window.MivaLayout = ml;

String.prototype.toCamelCase = function (str) {    
	return ((str ? '-' : '') + this).replace(/-+([^-])/g, function (a, b) {
		return b.toUpperCase();
	});
};

const pageId = document.body.id.toCamelCase();
console.log('page id is: ', pageId);

// Page Templates
const pageClasses = {
	jsABAL: () => import('./theme/pages/account'),
	jsACAD: () => import('./theme/pages/account'),
	jsACED: () => import('./theme/pages/account'),
	jsACLN: () => import('./theme/pages/account'),
	jsACRT: () => import('./theme/pages/account'),
	jsBASK: () => import('./theme/pages/basket'), // Basket contents
	jsBSKE: () => import('./theme/pages/checkout'), // Basket Empty
	jsCABK: () => import('./theme/pages/account'),
	jsCACT: () => import('./theme/pages/account'),
	jsCADA: () => import('./theme/pages/account'),
	jsCADE: () => import('./theme/pages/account'),
	jsCEML: () => import('./theme/pages/account'),
	jsCMPR: () => import('./theme/pages/compare'),
	jsCONFIGURATOR: () => import('./theme/pages/configurator'), // Configurator
	jsCPCA: () => import('./theme/pages/account'),
	jsCPCD: () => import('./theme/pages/account'),
	jsCPCE: () => import('./theme/pages/account'),
	jsCPWD: () => import('./theme/pages/account'),
	jsCSBE: () => import('./theme/pages/account'),
	jsCSUB: () => import('./theme/pages/account'),
	jsCTGY: () => import('./theme/pages/category'), // Category display
	jsCTGY_ANGULAR: () => import('./theme/pages/category'), // Category display: Angular
	jsCTGY_DESIGNER: () => import('./theme/pages/category'),
	jsCTGY_JSON: () => import('./theme/pages/category'), // Category display: JSON
	jsCTGY_MODEL: () => import('./theme/pages/category-model'), // Category display: Model selection
	jsCTGY_QSTN: () => import('./theme/pages/category'), // Questionnaire category template
	jsCTGY_QUESTION_BUILDER: () => import( './theme/pages/question-builder'),
	jsCTGY_SIZE: () => import('./theme/pages/category'), // Category display: size selection
	jsCTGY_SUBCAT: () => import('./theme/pages/category'), // Category display - subcategory listing
	jsCTGY_TOP: () => import('./theme/pages/category'), // category_display: top level
	jsCTGY_TOP_DESIGNER: () => import('./theme/pages/category'),
	jsCTGY_VISUAL: () => import('./theme/pages/category'), // category display: visual facets
	jsCTGY_STANDALONE: () => import('./theme/pages/ctgy-standalone'),
	jsCTLG: () => import('./theme/pages/category'), // our catalog
	jsGLRY: () => import('./theme/pages/react'), // image gallery
	jsINVC: () => import('./theme/pages/checkout'), // invoice
	jsLOGN: () => import('./theme/pages/account'),
	jsLOGOUT: () => import('./theme/pages/account'),
	jsOCST: () => import('./theme/pages/checkout'), // checkout: customer information
	jsOPAY: () => import('./theme/pages/checkout'), // checkout: payment information
	jsORDH: () => import('./theme/pages/account'),
	jsORDL: () => import('./theme/pages/checkout'), // order: customer login
	jsORDS: () => import('./theme/pages/checkout'), // order status
	jsOSEL: () => import('./theme/pages/checkout'), // checkout: shipping/payment selection
	jsOUSL: () => import('./theme/pages/checkout'),
	jsOUSM: () => import('./theme/pages/checkout'),
	jsPLST: () => import('./theme/pages/category'), // product list
	jsPROD: () => import('./theme/pages/product'), // product display
	jsQUOH: () => import('./theme/pages/account'),
	jsQUOT: () => import('./theme/pages/checkout'),
	jsRGFT: () => import('./theme/pages/account'),
	jsRSRC: () => import('./theme/pages/react'), // resource center
	jsSFNT: () => import('./theme/pages/storefront'), // Storefront
	jsSRCH: () => import('./theme/pages/category'), // search
	jsWISH: () => import('./theme/pages/account'),
	jsWLAD: () => import('./theme/pages/account'),
	jsWLED: () => import('./theme/pages/account'),
	jsWLGN: () => import('./theme/pages/account'),
	jsWLST: () => import('./theme/pages/account'),
	jsWPCK: () => import('./theme/pages/account')
};

/**
 * This function gets called on page load with the current template loaded and JS Context
 * @param pageType String
 * @param contextJSON Context to pass from the template
 * @returns {*}
 */
function mivaBootstrap(pageType, contextJSON = null, loadGlobal = true) {
	const context = JSON.parse(contextJSON || '{}');
	context.pageId = pageType;
	// Load globals
	if (loadGlobal) {
		Global.load(context);
	}
	const importPromises = [];
	// Find the appropriate page loader based on pageType
	const pageClassImporter = pageClasses[pageType];
	if (typeof pageClassImporter === 'function') {
		importPromises.push(pageClassImporter());
	}
	else {
		importPromises.push(import('./theme/pages/other'));
	}

	// Wait for imports to resolve, then call load() on them
	Promise.all(importPromises).then(imports => {
		imports.forEach(imported => {
			imported.default.load(context);
		});
	});
}

mivaBootstrap(pageId);
